(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/marionette/behaviors/updatecollection.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/marionette/behaviors/updatecollection.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.bingo.behaviors.UpdateCollection = Marionette.Behavior.extend({
    preventPolling: false,
    options: function() {
      return {
        resetView: 'resetView'
      };
    },

    onDestroy: function() {
      clearInterval(this.updateInterval);
      clearTimeout(this.updateTimeout);
    },

    onTogglePolling: function(state) {
      this.preventPolling = Boolean(state);
    },
    onSetClosingInterval: function(models) {
      var i; var dur; var model;
      clearInterval(this.updateInterval);
      this.updateInterval = setInterval(function() {
        for (i = 0; i < models.length; i++) {
          model = models[i];
          if (!model.get('disabled') && model.get('secondsLeft') > 0) {
            model.set('secondsLeft', model.get('secondsLeft') - 1);
            dur = dateFns.addSeconds(new Date(0), model.get('secondsLeft'));
            model
              .get('infoBar')
              .set(
                'date',
                dateFns.format(dur, 'mm:ss')
              );
          }
        }
      }, 1000);
    },

    onSetUpdateTimeout: function(items) {
      var returnObj;
      var self = this;
      clearTimeout(this.updateTimeout);
      this.updateTimeout = setTimeout(function() {
        if (self.preventPolling) {
          self.triggerMethod('setUpdateTimeout', items);
        } else {
          svs.bingo.nyxChannel
            .request('startpageOptions')
            .then(function(startPageConfig) {
              returnObj = svs.bingo.nyxChannel.request(
                'updateCollection',
                items,
                startPageConfig.promoRegion.defaultPromo.items
              );
              if (returnObj.requiresRender) {
                self.view.triggerMethod(self.getOption('resetView'));
              } else {
                self.triggerMethod('setUpdateTimeout', items);
              }
            });
        }
      }, 7000);
    }
  });
})(Backbone, _, svs);


 })(window);